import { useInterstateTheme } from '../../InterstateThemeProvider';
import { CheckCircleIcon, ExclamationCircleIcon, ExclamationTriangleIcon, InformationCircleIcon } from '../../Icons';
import { styled } from '@mui/material/styles';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const resolveTypeIcon = (type, theme) => {
  switch (type) {
    case 'info':
      {
        return /*#__PURE__*/_jsx(InformationCircleIcon, {
          fontSize: '14px',
          color: theme.tokens.ComponentSnackbarColorIconInfo
        });
      }
    case 'success':
      {
        return /*#__PURE__*/_jsx(CheckCircleIcon, {
          fontSize: '14px',
          color: theme.tokens.ComponentSnackbarColorIconSuccess
        });
      }
    case 'warning':
      {
        return /*#__PURE__*/_jsx(ExclamationTriangleIcon, {
          fontSize: '14px',
          color: theme.tokens.ComponentSnackbarColorIconWarning
        });
      }
    case 'error':
      {
        return /*#__PURE__*/_jsx(ExclamationCircleIcon, {
          fontSize: '14px',
          color: theme.tokens.ComponentSnackbarColorIconError
        });
      }
    default:
      {
        return null;
      }
  }
};
export const StyledTypeIcon = _ref => {
  let {
    type
  } = _ref;
  const theme = useInterstateTheme();
  const typeIcon = resolveTypeIcon(type, theme);
  const StyledIconContainer = useMemo(() => styled('div')(_ref2 => {
    let {
      theme
    } = _ref2;
    return {
      width: 'auto',
      height: 'auto',
      paddingRight: '12px',
      display: 'flex',
      marginTop: '2px'
    };
  }), []);
  return /*#__PURE__*/_jsx(StyledIconContainer, {
    className: 'ids-snackbar-type-icon',
    children: typeIcon
  });
};